import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueMq from 'vue-mq';
import VeeValidate from 'vee-validate';
import {
  i18n
} from '@/plugins/i18n-setup';
import {
  Trans
} from '@/plugins/Translation';
import VueGtag from 'vue-gtag';
import VueAwesomeSwiper from 'vue-awesome-swiper';

import './registerServiceWorker';

Vue.use(VueMq, {
  breakpoints: {
    xs: 376,
    sm: 640,
    ms: 768,
    md: 960,
    lg: 1200,
    xl: 1320,
    hd: 1700,
    inf: Infinity
  }
});
Vue.use(VueGtag, {
  config: {
    id: 'G-1SLSZ4HWDW',
    params: {
      send_page_view: false
    }
  }
}, router);
Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans);
Vue.prototype.changeLanguage = Trans.changeLanguage.bind(Trans);
Vue.prototype.APP_PATH = 'http://127.0.0.1:8000/';
// Vue.prototype.APP_PATH = 'https://app.nushenamel.am/';
Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false;
Vue.use(VeeValidate, {
  i18nRootKey: 'validations',
  i18n
});

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app');
